<template>
  <section class="find-vacancy-how-it-work  container">
    <div class="find-vacancy-how-it-work__content container-inner">
      <h2 class="find-vacancy-how-it-work__title">{{ section.title }}</h2>
      <div class="find-vacancy-how-it-work__list">
        <div v-for="(item, index) in section.items"
             :key="index"
             class="find-vacancy-how-it-work__item">
          <img :src="item.icon"
               :alt="item.text"
               class="find-vacancy-how-it-work__item-ico">
          <h3 class="find-vacancy-how-it-work__item-name">{{ item.text }}</h3>
        </div>
      </div>
      <router-link-modified :to="{name: 'find-vacancy-questionnaire'}"
                            class="find-vacancy-how-it-work__btn  base-btn  base-btn--green">
        {{ section.button }}
      </router-link-modified>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'FindVacancyPageHowItWork',
    props: {
      section: Object,
    },
    data() {
      return {}
    }
  }
</script>

<style lang="less">

</style>
